import { render } from "./UnitexInvoice.vue?vue&type=template&id=3b7ecd76"
import script from "./UnitexInvoice.vue?vue&type=script&lang=js"
export * from "./UnitexInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__